import components from './es/components'
import seo from './es/seo'
import pages from './es/pages'
import validation from './es/validation/index.json'

export default {
  components,
  seo,
  pages,
  validation,
}
